// Diese Funktion hebt das Bild der ausgewählten Variante in der Produktgalerie hervor
function HighlightVariantImage(event) {
    const variant = event.detail.variant;

    if (!variant?.featured_media?.id) {
        return;
    }

    const productGallery = document.querySelector('product-gallery');

    if (!productGallery) {
        return;
    }

    const mediaItems = productGallery.querySelectorAll('.product-gallery__media');

    mediaItems.forEach((mediaItem) => {
        mediaItem.style.order = '';
        mediaItem.style.gridColumn = '';
    });

    const selectedMedia = productGallery.querySelector(
        `[data-media-id="${variant.featured_media.id}"]`
    );

    if (!selectedMedia) {
        return;
    }

    selectedMedia.style.order = '-1';
    selectedMedia.style.gridColumn = '1 / -1';
}

document.addEventListener('variant:change', HighlightVariantImage);